import { styled } from 'styled-components'

import {
  FormattedMessage,
  CurrencyStringCents,
  InteractiveIcon,
} from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Typography } from '@b-stock/fe-core/design-system'
import { designColors } from '@b-stock/fe-core/theme'

const Msrp = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
  ${Typography.Body1}
  color: ${designColors.neutral.black};

  & svg {
    margin-left: 0.25rem;
  }
`

const MsrpTooltipContainer = styled.div`
  white-space: pre-line;
`

const StyledInteractiveIcon = styled(InteractiveIcon)`
  font-size: 1rem;
  margin-left: 0.25rem;
  color: ${designColors.neutral.darkGray};

  @media ${Breakpoints.max.medium} {
    font-size: 0.75rem;
  }
`

const ns = 'Auction.details.bid.details'

const FormattedMsrpLine = ({
  msrpPrice,
  units,
  currency,
  isUnmanifested,
}: {
  msrpPrice?: number
  units?: number
  currency: string
  isUnmanifested?: boolean
}) => {
  const type = isUnmanifested ? 'estimated' : 'actual'

  if (msrpPrice !== undefined && msrpPrice !== 0) {
    const price = <CurrencyStringCents value={msrpPrice} currency={currency} />
    const perUnit =
      units !== undefined && units > 0 ? (
        <CurrencyStringCents value={msrpPrice / units} currency={currency} />
      ) : null
    return (
      <Msrp data-testid="price-details-msrp">
        <FormattedMessage
          id={`${ns}.mrsp.${type}.${perUnit ? 'long' : 'short'}`}
          values={{
            price,
            ...(perUnit ? { perUnit } : {}),
          }}
        />
        <StyledInteractiveIcon tooltipProps={{ placement: 'bottom' }}>
          <MsrpTooltipContainer>
            <FormattedMessage id="Auction.details.tooltip.msrp" />
          </MsrpTooltipContainer>
        </StyledInteractiveIcon>
      </Msrp>
    )
  } else {
    return null
  }
}

export default FormattedMsrpLine
